import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CreatewallPage } from './createwall';

@NgModule({
  declarations: [
    CreatewallPage,
  ],
  imports: [
    IonicPageModule.forChild(CreatewallPage),
  ],
})
export class CreatewallPageModule {}



// WEBPACK FOOTER //
// ./src/pages/createwall/createwall.module.ts